import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getUserInfo } from '../utils/tokenManager';
import { getProductList } from '../services/productService';
import HotelPriceStockSettings from './HotelPriceStockSettings';
import PriceStockSettings from './PriceStockSettings';

/**
 * 상품 타입에 따라 적절한 가격/재고 관리 컴포넌트를 렌더링하는 라우터
 * 호텔 상품 -> HotelPriceStockSettings
 * 투어 상품 -> PriceStockSettings
 */
const PriceStockRouter = () => {
  const { productId } = useParams();
  const [productType, setProductType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProductType = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const { companyNo, userNo } = getUserInfo() || {};
        if (!companyNo || !userNo || !productId) {
          setError('필수 정보가 없습니다.');
          return;
        }

        // 상품 리스트에서 해당 상품 찾기
        const productList = await getProductList(companyNo, userNo);
        const product = (Array.isArray(productList) ? productList : []).find(
          p => String(p?.상품번호) === String(productId)
        );
        
        if (!product) {
          setError('상품 정보를 찾을 수 없습니다.');
          return;
        }
        
        const productKindCode = product.상품종류코드 || '';
// 001001 = 호텔, 001002 = 투어
        if (productKindCode === '001001') {
setProductType('호텔');
        } else {
          // 투어 또는 기타 상품은 기존 PriceStockSettings 사용
setProductType('투어');
        }
      } catch (err) {
        console.error('상품 타입 조회 실패:', err);
        // 에러 발생 시 기본값으로 투어 사용
        setProductType('투어');
      } finally {
        setLoading(false);
      }
    };

    fetchProductType();
  }, [productId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">상품 정보를 불러오는 중...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <p className="text-red-600 mb-4">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            다시 시도
          </button>
        </div>
      </div>
    );
  }

  // 상품 타입에 따라 적절한 컴포넌트 렌더링
  if (productType === '호텔') {
    return <HotelPriceStockSettings />;
  } else if (productType === '투어') {
    return <PriceStockSettings />;
  } else {
    // 기본값: 투어 컴포넌트 사용
    return <PriceStockSettings />;
  }
};

export default PriceStockRouter;
